import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';

export default function SsoCallbackPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center" data-testid="sso-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-600 mx-auto mb-3" />
        <p className="text-sm text-gray-500">Signing you in...</p>
      </div>
      <AuthenticateWithRedirectCallback />
    </div>
  );
}
